import { Link } from 'react-router-dom';

interface Props {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel = '查看更多' }: Props) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3">
        <span className="w-1.5 h-7 rounded-full bg-primary-500"></span>
        <div>
          <h2 className="text-lg md:text-2xl font-bold text-foreground-950">{title}</h2>
          {subtitle && <p className="text-xs md:text-sm text-foreground-600 mt-1">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="text-sm text-foreground-600 hover:text-primary-400 transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}